/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpsertUserGroupDto
 */
export interface UpsertUserGroupDto {
    /**
     * The display name.
     * @type {string}
     * @memberof UpsertUserGroupDto
     */
    name: string;
}

/**
 * Check if a given object implements the UpsertUserGroupDto interface.
 */
export function instanceOfUpsertUserGroupDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function UpsertUserGroupDtoFromJSON(json: any): UpsertUserGroupDto {
    return UpsertUserGroupDtoFromJSONTyped(json, false);
}

export function UpsertUserGroupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertUserGroupDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function UpsertUserGroupDtoToJSON(value?: UpsertUserGroupDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

